export const getInitialState = (): any => ({
  dataProcessingMergeProgressData: {}
});
